import t from"react";const e=({schema:e})=>t.createElement("script",{type:"application/ld+json","data-testid":"jsonld-script",dangerouslySetInnerHTML:{__html:JSON.stringify(e)}});export{e as default};
